
const COLORS = {
    // Also needs to be changed in the index.css
    backgroundColor: '#171923',

    primaryText: '#FFFFFF',
    secondaryText: '#C4D1EE',
    ternaryText: '#A0A0A0',

    primaryTextInverted: '#000000',
    secondaryTextInverted: '#3B2E11',
    ternaryTextInverted: '#606060',

    inputBackground: '#F3F8FF',
    inputBackgroundHover: '#E4EDF7',
    inputBorder: '#E3E8EF',
    inputText: '#171923',
    inputImage: '#2F3747',

    action: '#176AFF',
    actionHover: '#3b7ef7',
    actionDisabled: '#9c9c9c',
    option: '#F68831',
    optionHover: '#f7cba8',

    featureSelectorBackground: '#1E2631',
    featureSelectorHeaderBackground: '#2B3747',
    featureSelectorBorder: '#C6CCD9',
    featureBackground: '#E4EDF7',
    featureText: '#1E2631',

    previewTag: '#9985FC',
    communityTag: '#F25B86',

    tooltipBackground: '#CBD6E5',
    tooltipText: '#667386',

    optionBorder: '#E3E8EF99',
    optionShadow: '-4px -4px 16px rgba(23, 106, 255, 0.05), 8px 12px 18px rgba(61, 131, 255, 0.1)',

    codeBackground: '#2e3949',
    codeBackgroundHover: '#4d5c71',
    codeBackgroundInactive: '#384455'
}

export default COLORS;
